package dev.lingvo.site.components.editor

import dev.lingvo.shared.KeyRow
import dev.lingvo.shared.MtProvider

internal data class EditorGenerationKey(
    val keyId: String,
    val provider: MtProvider,
)

internal data class EditorGenerationClaim(
    val projectSlug: String,
    val locale: String,
    val keyId: String,
    val provider: MtProvider,
) {
    val key = EditorGenerationKey(keyId, provider)
}

internal class EditorGenerationRequest internal constructor(
    val claim: EditorGenerationClaim,
    internal val row: KeyRow,
    internal val requestId: Long,
    internal val statusPublicationId: Long,
)

internal sealed interface EditorGenerationStatus {
    val claim: EditorGenerationClaim
    val sequence: Long

    data class Running(
        override val claim: EditorGenerationClaim,
        internal val requestId: Long,
        override val sequence: Long = 0L,
    ) : EditorGenerationStatus

    data class Succeeded(
        override val claim: EditorGenerationClaim,
        val suggestion: EditorSuggestion.Machine,
        override val sequence: Long = 0L,
    ) : EditorGenerationStatus

    data class NoResult(
        override val claim: EditorGenerationClaim,
        val message: String,
        override val sequence: Long = 0L,
    ) : EditorGenerationStatus

    data class Failed(
        override val claim: EditorGenerationClaim,
        val message: String,
        override val sequence: Long = 0L,
    ) : EditorGenerationStatus
}
